"use strict";
/**
 * getIxPrebidSizes
 * Takes a placement config object
 * Returns prebid bidder configs for each size the IX unit supports
 * @param {object} placementDetails Application config
 * @return {array} ixBidders list containing objects with the following nested params:
 * siteId: ixSiteId from application config
 * size: array conforming  to [w, h] format, indicating what size creative
 * the unit supports. IX requires each size to be configured as a different bidder
 * for the same unit
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIxPrebidSizes = void 0;
var getPlacementSizes_1 = require("./getPlacementSizes");
var placementUtils_1 = require("../../../helpers/placementUtils");
function getIxPrebidSizes(placement) {
    var ixBidders = [];
    var sizes = (0, getPlacementSizes_1.getPlacementSizes)(placement);
    var ixSiteId = (0, placementUtils_1.getIxSiteId)(placement);
    if (ixSiteId && sizes) {
        for (var _i = 0, sizes_1 = sizes; _i < sizes_1.length; _i++) {
            var size = sizes_1[_i];
            ixBidders.push({
                bidder: "ix",
                params: {
                    siteId: ixSiteId,
                    size: size,
                },
            });
        }
    }
    return ixBidders;
}
exports.getIxPrebidSizes = getIxPrebidSizes;
